// extracted by mini-css-extract-plugin
export default {"wrapper":"Page404_wrapper__W0dBu","content":"Page404_content__oCRyW","home":"Page404_home__UB4gs"};